var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "subscription-interval-selector" }, [
    _c("label", { staticClass: "subscription-interval-selector-label" }, [
      _vm._v(_vm._s(_vm.translations.deliverEveryText))
    ]),
    _vm._v(" "),
    _c(
      "select",
      {
        staticClass: "subscription-interval-selector-input",
        attrs: { type: "select" },
        on: {
          change: function($event) {
            return _vm.onChange($event)
          }
        }
      },
      _vm._l(_vm.shippingIntervalFrequency, function(frequency) {
        return _c("option", { domProps: { value: frequency } }, [
          _vm._v(
            _vm._s(frequency) +
              " " +
              _vm._s(
                _vm._f("pluralize")(
                  _vm.shippingIntervalUnitType,
                  parseInt(frequency)
                )
              )
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }